export default __webpack_public_path__ + "static/media/new_logo.01dbc8ad.png";